import api from "../api";
import backEnd from "../../constants/backEnd";

const postImagePackCheckout = async (packId) => {
    const response = await api.post(`${backEnd.url}webhooks/stripe/images/checkout/`, {
        pack_id: packId,
    });
    
    return response.data;
};

export default postImagePackCheckout;
